import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios";
import { Collapse } from "@material-ui/core";
import UploadFile from "./uploadFiles";
import "../report-styles/UploadFile.styles.scss";
import UploadIcon from "../svgs/upload.svg";
import UploadModule from "./uploadModule";
export default function EmailForm({ upload }) {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [msg, setMsg] = React.useState(null);
  const [showButton, setShowButton] = React.useState(true);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   console.log(email);
  // }, [email]);

  return (
    <div>
      <div onClick={handleClickOpen} className="link-button">
        <img className="upload-icon" src={UploadIcon} />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth={upload.uploadVariations ? true : false}
      >
        <h2 className="variants-dialog-title-upload">{upload.title}</h2>
        <DialogContent>
          <p className="header-title-change-password-upload">
            {" "}
            Please enter a valid mail address you have been registered with
          </p>

          <Collapse in={msg ? true : false}>
            <h3 className="success-message-change-password">{msg}</h3>
          </Collapse>
          <div className="change-pass-group">
            <input
              value={email}
              onChange={(e) => {
                e.preventDefault();
                setEmail(e.target.value);
              }}
              placeholder={"Enter a valid email address"}
              type="text"
              disabled={!showButton ? true : false}
              style={{ borderColor: "rgb(226 20 110)" }}
              // defaultValue={this.state.name}
            />
          </div>

          {upload.uploadVariations && (
            <div
              className={
                upload.isEmailRequired && !validateEmail(email)
                  ? "upload-variants-container disabled"
                  : "upload-variants-container"
              }
            >
              {upload.uploadVariations.map((upload, index) => (
                <UploadModule
                  key={upload.title}
                  upload={upload}
                  index={index}
                  historyData={[]}
                  eMail={email ?? null}
                  customIndex={upload.customIndex}
                />
              ))}
            </div>
          )}
        </DialogContent>
        {!upload.uploadVariations && showButton && (
          <DialogActions>
            <button
              className="upload-email-form-button"
              color="primary"
              autoFocus
              disabled={!validateEmail(email)}
            >
              <UploadFile
                heading={upload.title}
                api={upload.api}
                help={upload.helpText ? upload.helpText : null}
                varients={upload.varients || []}
                eMail={email}
                isEmailRequired={upload.isEmailRequired}
                feedback={upload.feedback}
              />
            </button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
